const withSessionQnaApi = (Base) => class extends Base {
  async getSessionQna(sessionId) {
    return this.request(`/attendance/${sessionId}/qna`);
  }

  async postSessionQuestion(sessionId, body, isAnonymous = false) {
    return this.request(`/attendance/${sessionId}/qna/questions`, {
      method: 'POST',
      body: JSON.stringify({ body, is_anonymous: isAnonymous }),
    });
  }

  async postSessionQuestionReply(sessionId, questionId, body) {
    return this.request(`/attendance/${sessionId}/qna/questions/${questionId}/replies`, {
      method: 'POST',
      body: JSON.stringify({ body }),
    });
  }

  async toggleSessionQnaReaction(sessionId, targetType, targetId, reactionType) {
    return this.request(`/attendance/${sessionId}/qna/${targetType}/${targetId}/reactions`, {
      method: 'POST',
      body: JSON.stringify({ reaction_type: reactionType }),
    });
  }

  async editSessionQnaMessage(sessionId, targetType, targetId, body) {
    return this.request(`/attendance/${sessionId}/qna/${targetType}/${targetId}`, {
      method: 'PATCH',
      body: JSON.stringify({ body }),
    });
  }

  async deleteSessionQnaMessage(sessionId, targetType, targetId) {
    return this.request(`/attendance/${sessionId}/qna/${targetType}/${targetId}`, {
      method: 'DELETE',
    });
  }
};

export default withSessionQnaApi;
